import type { AdminIdentity } from "@player115/contracts";
import { useEffect, useState } from "react";
import { api } from "./api";
import { Shell, type Screen } from "./components/Shell";
import { CommercePage, SystemPage } from "./pages/ComingSoonPage";
import { DashboardPage } from "./pages/DashboardPage";
import { FeaturesPage } from "./pages/FeaturesPage";
import { LoginPage, PasswordChangePage, TwoFactorPage } from "./pages/LoginPage";
import { ReleasesPage } from "./pages/ReleasesPage";
import { SecurityPage } from "./pages/SecurityPage";

export function App() {
  const [admin, setAdmin] = useState<AdminIdentity | null>(null);
  const [checking, setChecking] = useState(true);
  const [totpChallenge, setTotpChallenge] = useState<string | null>(null);
  const [screen, setScreen] = useState<Screen>("dashboard");
  useEffect(() => {
    api.me().then((result) => setAdmin(result.admin)).catch(() => undefined).finally(() => setChecking(false));
  }, []);
  if (checking) return <main className="boot-screen"><span /><strong>正在读取控制台状态</strong></main>;
  if (!admin && totpChallenge) return <TwoFactorPage
    onVerify={async (code) => {
      setAdmin((await api.verifyTotpLogin(totpChallenge, code)).admin);
      setTotpChallenge(null);
    }}
    onBack={() => setTotpChallenge(null)}
  />;
  if (!admin) return <LoginPage onLogin={async (username, password) => {
    const result = await api.login(username, password);
    if (result.requiresTotp) setTotpChallenge(result.challengeToken);
    else setAdmin(result.admin);
  }} />;
  if (admin.passwordChangeRequired) return <PasswordChangePage
    admin={admin}
    onChange={async (password) => setAdmin((await api.changePassword(password)).admin)}
    onLogout={() => void api.logout().finally(() => setAdmin(null))}
  />;
  const content = screen === "dashboard" ? <DashboardPage />
    : screen === "releases" ? <ReleasesPage />
      : screen === "features" ? <FeaturesPage />
        : screen === "commerce" ? <CommercePage />
          : screen === "security" ? <SecurityPage admin={admin} onAdminChange={setAdmin} />
            : <SystemPage />;
  return <Shell admin={admin} screen={screen} onScreen={setScreen} onLogout={() => void api.logout().finally(() => setAdmin(null))}>{content}</Shell>;
}
